import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Hacé una rutina',
    desc: 'Ya la hiciste… y ahora dura 45 minutos de negociación constante.'
  }, {
    title: 'Poné límites',
    desc: 'Intentás ponerte firme y termina en una escalada de gritos y llanto.'
  }, {
    title: 'Que llore y se acostumbre',
    desc: 'No te cierra dejarlo llorar (o no te sale sostenerlo cuando estás agotado).'
  }, {
    title: 'Hablale y explicale',
    desc: 'A las 23:15 no hay charla pedagógica que funcione con un cerebro cansado.'
  }];
  return <section className="py-20 px-6 bg-[#1C1C2E] text-[#F5F0E8]" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-15">
            Lo que normalmente te recomiendan <br data-id="element-16" />
            <span className="text-[#5A8A7A] italic" data-id="element-17">
              (y por qué no te sirve)
            </span>
          </h2>
          <p className="text-xl text-[#F5F0E8]/80 max-w-2xl mx-auto" data-id="element-18">
            No necesitás más teoría. Necesitás un plan que puedas ejecutar
            cuando estás destruido/a.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-19">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#14142B] p-6 rounded-xl border border-[#F5F0E8]/5 hover:border-[#5A8A7A]/30 transition-colors group" data-id="element-20">
              <div className="flex items-start gap-4" data-id="element-21">
                <XCircle className="w-6 h-6 text-[#5A8A7A] flex-shrink-0 mt-1 group-hover:text-[#D4A574] transition-colors" data-id="element-22" />
                <div data-id="element-23">
                  <h3 className="text-xl font-serif font-semibold text-white mb-2" data-id="element-24">
                    "{item.title}"
                  </h3>
                  <p className="text-[#F5F0E8]/70 leading-relaxed" data-id="element-25">
                    {item.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}